module.exports = __webpack_public_path__ + "static/media/login_page.e3c74220.png";